module.exports = __webpack_public_path__ + "img/D2_HQ01.3b0ce6bd.jpg";